/* VOLTA Landing Page — interactions (no theme id reliance, all querySelector) */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---------- Smooth scroll to offer ---------- */
    /* Use scrollIntoView so it works no matter which element is the scroll
       container — the window on mobile, .page-wrapper on desktop in this theme.
       (The old code scrolled a hardcoded .page-wrapper, which isn't the scroller
       on mobile, so the hero + final CTAs did nothing when tapped on phones.) */
    document.querySelectorAll('a[href="#vlp-offer"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.querySelector('[data-vlp-anchor="offer"]') || document.querySelector('.vlp-offer');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    /* ---------- Force-load gallery images (Horizon scroll container breaks native lazy) ---------- */
    /* Visible colour: right after page load (first photo already loads eagerly). Hidden colours: only once shown. */
    (function () {
      function forceLoad(scope) {
        scope.querySelectorAll('img').forEach(function (img) {
          img.removeAttribute('loading');
          if (!img.complete || img.naturalWidth === 0) {
            var src = img.getAttribute('src');
            img.removeAttribute('src');
            img.setAttribute('src', src);
          }
        });
      }
      function isShown(cs) { return cs.style.display !== 'none'; }
      var sets = Array.prototype.slice.call(document.querySelectorAll('.vlp-offer-colorset'));
      function loadVisible() { sets.forEach(function (cs) { if (isShown(cs)) forceLoad(cs); }); }
      if (!sets.length) {
        document.querySelectorAll('.vlp-offer-gallery img').forEach(function (img) { img.removeAttribute('loading'); });
        return;
      }
      // …and only once the gallery is near the screen (on the homepage it sits far down).
      function whenNear() {
        if (!('IntersectionObserver' in window)) return loadVisible();
        var near = new IntersectionObserver(function (entries) {
          if (entries.some(function (en) { return en.isIntersecting; })) { near.disconnect(); loadVisible(); }
        }, { rootMargin: '600px 0px' });
        sets.forEach(function (cs) { near.observe(cs.closest('.vlp-offer-gallery') || cs); });
      }
      if (document.readyState === 'complete') whenNear(); else window.addEventListener('load', whenNear);
      if ('MutationObserver' in window) {
        var mo = new MutationObserver(function (muts) {
          muts.forEach(function (m) { if (isShown(m.target)) forceLoad(m.target); });
        });
        sets.forEach(function (cs) { mo.observe(cs, { attributes: true, attributeFilter: ['style'] }); });
      }
    })();

    /* ---------- Gallery carousel (multi-track, color-aware) ---------- */
    (function () {
      Array.prototype.slice.call(document.querySelectorAll('[data-vlp-track]')).forEach(function (track) {
        var scope = track.closest('.vlp-offer-colorset') || document;
        var thumbsWrap = scope.querySelector('[data-vlp-thumbs]');
        var thumbs = thumbsWrap ? Array.prototype.slice.call(thumbsWrap.querySelectorAll('[data-vlp-thumb]')) : [];

        function setActive(i) {
          thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
          var active = thumbs[i];
          if (active && thumbsWrap) {
            var tl = active.offsetLeft - thumbsWrap.clientWidth / 2 + active.clientWidth / 2;
            thumbsWrap.scrollTo({ left: tl, behavior: 'smooth' });
          }
        }

        thumbs.forEach(function (t, i) {
          t.addEventListener('click', function () {
            track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
            setActive(i);
          });
        });

        var raf;
        track.addEventListener('scroll', function () {
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var i = Math.round(track.scrollLeft / track.clientWidth);
            setActive(i);
          });
        });
      });
    })();

    /* ---------- Bundle selector ---------- */
    (function () {
      var wrap = document.querySelector('[data-vlp-bundles]');
      if (!wrap) return;
      var rows = Array.prototype.slice.call(wrap.querySelectorAll('.vlp-bundle-row'));
      var variantInput = document.querySelector('[data-vlp-variant-input]');
      var ctaPrice = document.querySelector('[data-vlp-cta-price]');

      function select(row) {
        rows.forEach(function (r) {
          r.classList.remove('is-active');
          var radio = r.querySelector('input[type="radio"]');
          if (radio) radio.checked = false;
        });
        row.classList.add('is-active');
        var radio = row.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        var variant = row.getAttribute('data-vlp-variant');
        var price = row.getAttribute('data-vlp-price');
        if (variantInput && variant) variantInput.value = variant;
        if (ctaPrice && price) ctaPrice.textContent = price;
      }

      rows.forEach(function (row) {
        row.addEventListener('click', function () { select(row); });
      });

      // Ensure the initial active row syncs the hidden input on load
      var initial = wrap.querySelector('.vlp-bundle-row.is-active') || rows[0];
      if (initial) select(initial);
    })();

    /* ---------- FAQ accordion ---------- */
    (function () {
      var list = document.querySelector('[data-vlp-faq]');
      if (!list) return;
      list.querySelectorAll('.vlp-faq-q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.vlp-faq-item');
          var answer = item.querySelector('.vlp-faq-a');
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          answer.style.maxHeight = open ? '0px' : (answer.scrollHeight + 'px');
        });
      });
    })();

    /* ---------- Cart-pop animation on add-to-cart ---------- */
    (function () {
      var cartIcon = document.querySelector('.header-actions__cart-icon');
      var bubble = document.querySelector('.cart-bubble');
      if (!cartIcon || !bubble) return;

      var popping = false;

      function pop() {
        if (popping) return;
        popping = true;
        cartIcon.classList.remove('vlp-cart-pop');
        bubble.classList.remove('vlp-badge-pop');
        void cartIcon.offsetWidth;
        cartIcon.classList.add('vlp-cart-pop');
        bubble.classList.add('vlp-badge-pop');
        setTimeout(function () { popping = false; }, 900);
      }

      cartIcon.addEventListener('animationend', function () {
        cartIcon.classList.remove('vlp-cart-pop');
      });
      bubble.addEventListener('animationend', function () {
        bubble.classList.remove('vlp-badge-pop');
      });

      var countEl = bubble.querySelector('.cart-bubble__text');
      var lastCount = countEl ? countEl.textContent.trim() : '';

      var observer = new MutationObserver(function () {
        var nowHidden = bubble.classList.contains('visually-hidden');
        if (nowHidden) return;
        var currentCount = countEl ? countEl.textContent.trim() : '';
        if (currentCount !== lastCount) {
          lastCount = currentCount;
          pop();
        }
      });

      observer.observe(bubble, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true,
        childList: true,
        characterData: true
      });
    })();

    /* ---------- Scroll reveal ---------- */
    (function () {
      var els = document.querySelectorAll('.vlp-reveal');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    })();

    /* ---------- Showcase video: muted autoplay-on-view + play/pause + seek ---------- */
    (function () {
      var wraps = document.querySelectorAll('[data-vlp-video-wrap]');
      if (!wraps.length) return;

      wraps.forEach(function (wrap) {
        var v = wrap.querySelector('[data-vlp-video]');
        var playBtn = wrap.querySelector('[data-vlp-play]');
        var seek = wrap.querySelector('[data-vlp-seek]');
        if (!v) return;
        v.muted = true; // always muted (the file also has no audio track)
        // The source is deferred (data-src + poster) so the 3 MB clip only loads once the slide is reached.
        function attach() {
          if (v.getAttribute('src') || !v.getAttribute('data-src')) return;
          v.preload = 'auto';
          v.setAttribute('src', v.getAttribute('data-src'));
        }

        var userPaused = false;
        function sync() { wrap.classList.toggle('is-playing', !v.paused); }

        if (playBtn) {
          playBtn.addEventListener('click', function () {
            if (v.paused) { userPaused = false; attach(); v.play().catch(function () {}); }
            else { userPaused = true; v.pause(); }
          });
        }
        v.addEventListener('play', sync);
        v.addEventListener('pause', sync);

        if (seek) {
          v.addEventListener('timeupdate', function () {
            if (v.duration && document.activeElement !== seek) {
              seek.value = (v.currentTime / v.duration) * 100;
            }
          });
          seek.addEventListener('input', function () {
            if (v.duration) v.currentTime = (seek.value / 100) * v.duration;
          });
          // keep dragging the slider from scrolling the carousel
          ['pointerdown', 'touchstart', 'mousedown'].forEach(function (ev) {
            seek.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true });
          });
        }

        // Autoplay while on screen, but never override a manual pause.
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting) { if (!userPaused) { attach(); v.play().catch(function () {}); } }
              else { v.pause(); }
            });
          }, { threshold: 0.5 });
          io.observe(v);
          // start fetching as soon as any part of the slide comes into view
          var pre = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { if (en.isIntersecting) { attach(); pre.unobserve(v); } });
          });
          pre.observe(v);
        } else {
          attach();
          v.play().catch(function () {});
        }
        sync();
      });
    })();

    /* ---------- "Volta in actie" videos: muted, start on first scroll-into-view, loop forever ---------- */
    (function () {
      var vids = document.querySelectorAll('[data-vlp-autoplay]');
      if (!vids.length) return;
      vids.forEach(function (v) { v.muted = true; v.loop = true; });
      // Sources are deferred (data-src) so the videos don't compete with the first screen for bandwidth.
      function attach(v) {
        if (v.getAttribute('src') || !v.getAttribute('data-src')) return;
        v.preload = 'metadata';
        v.setAttribute('src', v.getAttribute('data-src'));
      }
      if (!('IntersectionObserver' in window)) {
        vids.forEach(function (v) { attach(v); v.play().catch(function () {}); });
        return;
      }
      // Fetch a bit before it scrolls into view…
      var pre = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { attach(en.target); pre.unobserve(en.target); } });
      }, { rootMargin: '300px 0px' });
      // …play once it is in view, then stop observing so it never pauses.
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { attach(en.target); en.target.play().catch(function () {}); io.unobserve(en.target); }
        });
      }, { threshold: 0.3 });
      vids.forEach(function (v) { pre.observe(v); io.observe(v); });
    })();

    /* ---------- "Volta in actie" carousel arrows (scroll one card per click) ---------- */
    (function () {
      document.querySelectorAll('[data-vlp-actie]').forEach(function (row) {
        var wrap = row.parentElement;
        if (!wrap) return;
        var prev = wrap.querySelector('[data-vlp-actie-prev]');
        var next = wrap.querySelector('[data-vlp-actie-next]');
        function step(dir) {
          var card = row.querySelector('.vlp-actie-card');
          var amount = card ? (card.getBoundingClientRect().width + 18) : row.clientWidth * 0.8;
          row.scrollBy({ left: dir * amount, behavior: 'smooth' });
        }
        if (prev) prev.addEventListener('click', function () { step(-1); });
        if (next) next.addEventListener('click', function () { step(1); });
      });
    })();
  });
})();
